module.exports = __webpack_public_path__ + "img/twilio-logo.0bce2d3c.png";